import httpClient from '@/utils/httpClient'
import type { LegalDocumentSection } from '../types'

const legalDocumentSectionsService = {
  fetchAll: async (documentId: string): Promise<Record<string, LegalDocumentSection>> => {
    const response = await httpClient.get<Record<string, LegalDocumentSection>>(`/v1/documents/${documentId}/sections`)

    return response.data
  },
}

export default legalDocumentSectionsService
